import Card from '@/components/ui/Card'

export default function RentAssistanceAbout() {
  return (
    <div className="space-y-8">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-cocoa">Rent Assistance</h1>
        <span className="inline-flex items-center gap-2 rounded-full bg-shell px-3 py-1 text-sm font-medium uppercase tracking-wide text-cocoa/70">
          Preview — Coming soon
        </span>
        <p className="text-cocoa/70">
          Emergency assistance so families can stay housed. We are building partnerships and systems before launching sponsorships.
        </p>
      </header>
      <Card className="p-5 text-sm text-cocoa/80">
        We’re lining up trusted community partners and compliance workflows. Sponsors will be able to fund urgent requests with transparency and real-time updates when this program goes live.
      </Card>
    </div>
  )
}
